import * as Tooltip from '@radix-ui/react-tooltip';
import { useAuth } from '@context/AuthContext';
import sidebarMenu, { isSidebarMenuItemVisible } from './sidebarMenu';
import { SidebarMenuLink } from './SidebarMenuLink';
import { Svgs, Images } from '@/assets';
import './Sidebar.scss';

interface SidebarProps {
  isOpen: boolean;
}

const Sidebar = ({ isOpen }: SidebarProps) => {
  const { hasPermission, isSuperAdmin } = useAuth();
  return (
    <Tooltip.Provider delayDuration={250} skipDelayDuration={200}>
      <aside
        className={`sidebar h-screen bg-[var(--navy)] transition-all duration-300 z-[9] ${isOpen ? 'w-[220px] 2xl:w-[250px]' : 'w-[50px] 2xl:w-[60px]'
          }`}
      >
        {/* Logo */}
        <div className="py-1 2xl:py-[10px] px-1 2xl:px-[10px] border-b border-[var(--primary-strong-color)] flex items-center justify-center h-[50px] 2xl:h-[79px]">
          {isOpen ? (
            <img
              src={Images.tpaLogo}
              className="h-6 w-auto object-contain brightness-0 invert"
              alt="The Purpose Academy"
            />
          ) : (
            <div>
              <img
                  src={Svgs.logosm}
                  className="h-7 2xl:h-10 w-7 2xl:w-10 object-contain brightness-0 invert"
                  alt="QualityPulse"
              />
            </div>
          )}
        </div>

        {/* Navigation */}
        <nav className={`py-[10px] 2xl:py-[20px] max-h-[calc(100vh-50px)] 2xl:max-h-[calc(100vh-79px)] overflow-auto custom-scroll ${isOpen ? 'px-[10px]' : 'px-[7px] 2xl:px-[10px]'}`}
        >
          {sidebarMenu.map((group, gi) => {
            const visibleItems = group.items.filter((item) =>
              isSidebarMenuItemVisible(item, isSuperAdmin, hasPermission),
            );
            if (visibleItems.length === 0) return null;
            return (
              <div
                key={gi}
                className={`${isOpen ? 'mb-4 2xl:mb-5' : 'mb-1.5 2xl:mb-2.5'}`}
              >
                {group.label && isOpen && (
                  <span className="block text-[10px] 2xl:text-[12px] font-medium uppercase text-[var(--primary-soft-color)] select-none leading-none mb-[8px] 2xl:mb-[10px]">
                    {group.label}
                  </span>
                )}
                {visibleItems.map((item) => (
                  <SidebarMenuLink key={item.path} item={item} isOpen={isOpen} />
                ))}
              </div>
            );
          })}
        </nav>
      </aside>
    </Tooltip.Provider>
  );
}

export default Sidebar;
